import React from "react";

function NotNullableIcon() {
  return (
    <svg viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.21967 2.21967C2.36032 2.07902 2.55109 2 2.75 2H11C11.4142 2 11.75 1.66421 11.75 1.25C11.75 0.835786 11.4142 0.5 11 0.5H2.75C2.15326 0.5 1.58097 0.737053 1.15901 1.15901C0.737053 1.58097 0.5 2.15326 0.5 2.75V13.25C0.5 13.8467 0.737053 14.419 1.15901 14.841C1.58097 15.2629 2.15326 15.5 2.75 15.5H13.25C13.8467 15.5 14.419 15.2629 14.841 14.841C15.2629 14.419 15.5 13.8467 15.5 13.25V8C15.5 7.58579 15.1642 7.25 14.75 7.25C14.3358 7.25 14 7.58579 14 8V13.25C14 13.4489 13.921 13.6397 13.7803 13.7803C13.6397 13.921 13.4489 14 13.25 14H2.75C2.55109 14 2.36032 13.921 2.21967 13.7803C2.07902 13.6397 2 13.4489 2 13.25V2.75C2 2.55109 2.07902 2.36032 2.21967 2.21967Z"
        fill="#2D3648"
      />
      <path
        d="M8.53033 10.0303L16.0303 2.53033C16.3232 2.23744 16.3232 1.76256 16.0303 1.46967C15.7374 1.17678 15.2626 1.17678 14.9697 1.46967L8 8.43934L6.28033 6.71967C5.98744 6.42678 5.51256 6.42678 5.21967 6.71967C4.92678 7.01256 4.92678 7.48744 5.21967 7.78033L7.46967 10.0303C7.76256 10.3232 8.23744 10.3232 8.53033 10.0303Z"
        fill="#2D3648"
      />
    </svg>
  );
}

export default NotNullableIcon;
